import { useFlag } from '@rsos/flags';
import useHasAccessToAirAmbulance from '@rsos/hooks/useHasAccessToAirAmbulance';

/**
 * Helper for the GMR Air Ambulance integration resource request experience.
 */
const useHasAccessToGmrResourceRequests = (): boolean => {
  const hasAirAmbulanceAccess = useHasAccessToAirAmbulance();
  const hasEtl = useFlag('air_ambulance_etl_integrations');
  const hasGeneric = useFlag('generic_resource_requests');

  return hasAirAmbulanceAccess && hasEtl && hasGeneric;
};

export default useHasAccessToGmrResourceRequests;
